// app/frontend/components/ui/Loaders/ThemedSpinner.tsx
import React from 'react';
import { Loader, type LoaderProps } from '@mantine/core';

export interface ThemedSpinnerProps extends LoaderProps {}

const ThemedSpinner = React.forwardRef<HTMLSpanElement, ThemedSpinnerProps>(
  ({ color = '#EA580C', ...props }, ref) => {
    return <Loader ref={ref} color={color} {...props} />;
  }
);

ThemedSpinner.displayName = 'ThemedSpinner';

export default ThemedSpinner;
